(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/submit-button.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/submit-button.js');
"use strict";


const Button = svs.ui.Button;
const SubmitButton = _ref => {
  let children = _ref.children,
    onClick = _ref.onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    className = _ref.className,
    formName = _ref.formName;
  return React.createElement(Button, {
    className: "payfooter-button ".concat(className),
    disabled: disabled,
    focus: true,
    form: formName,
    onClick: onClick,
    type: "submit"
  }, children);
};
svs.tur.ReactPayfooter.SubmitButton = SubmitButton;

 })(window);